import { PureComponent } from 'react'
import { Link } from 'react-router-dom';
import { Table, Row, Col, Button, Alert, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { title_evaluation_load, default_load_button_info_tooltip_timeout } from '../Consts';

export class EvaluationLoad extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showLoadAnimation: false,
        };
    }

    componentDidMount() {
        this.handleQueryParams();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.search !== prevProps.location.search) {
            this.handleQueryParams();
        }
    }

    handleQueryParams = () => {
        const { location } = this.props;
        // console.log(location);
        const queryParams = new URLSearchParams(location.search);
        const triggerParam = queryParams.get('trigger');

        if (triggerParam === 'load') {
            this.setState({ showLoadAnimation: true });
            setTimeout(() => {
                this.setState({ showLoadAnimation: false });
            }, default_load_button_info_tooltip_timeout);
        }
    }

    handleUploadButtonClick = () => {
        document.getElementById('inputFileUpload').click();
    };

    handleUploadLabelClick = (e) => {
        e.stopPropagation();
    };

    handleFileLoadChange = (e, x) => {
        e.preventDefault();
        if (e.target.files.length > 0) {
            const files = e.target.files;
            const file = files[0];
            if (file.type.startsWith("application/json")) {
                const reader = new FileReader();
                reader.onloadend = (function (theFile) {
                    return function (e) {
                        try {
                            if (e.target.readyState === FileReader.DONE) {
                                const fContent = e.target.result;
                                const fContentObj = JSON.parse(fContent);

                                if (fContentObj.hasOwnProperty('type') && fContentObj.type === 'indi11_eval' &&
                                    fContentObj.hasOwnProperty('statusExams')) {
                                    x.props.backCallerLoadState(fContentObj);
                                    x.props.backCallerSetNotice(
                                        "Ein Auswertungsstand wurde aus der Datei " + file.name + " in die Anwendung eingespielt.",
                                        "Auswertungsstand geladen",
                                        "info"
                                    );
                                } else {
                                    throw new Error("The file does not contain a valid evaluation state.");
                                }
                            }
                        } catch (error) {
                            // console.error("An error occurred while processing the file:", error);
                            x.props.backCallerSetNotice("Der Auswertungsstand " + file.name + " konnte nicht geladen werden. " +
                                "Sie können nur einen Auswertungsstand einspielen, der mit dieser Anwendung erstellt wurde. " +
                                "Haben Sie eventuell versucht eine Klassenarbeit einzuspielen?",
                                "Auswertungsstand nicht geladen",
                                "danger"
                            );
                        }

                    };
                })(file);
                reader.readAsText(file);
            }
            else {
                x.props.backCallerSetNotice("Der Auswertungsstand " + file.name + " konnte nicht geladen werden. " +
                    "Sie können nur einen Auswertungsstand einspielen, der mit dieser Anwendung erstellt wurde. Bitte prüfen Sie das Dateiformat.",
                    "Auswertungsstand nicht geladen",
                    "warning");
            }
            e.target.value = "";
        }
    }

    render() {
        return (
            <>
                <h5 className="mb-3">{title_evaluation_load}</h5>
                {this.props.parentState.klassenarbeiten.length === 1 &&
                    <h6 className="mb-3">
                        Ihr Analysestand enthält <span className="fw-bold">eine</span> Klassenarbeit.
                    </h6>
                }
                {this.props.parentState.klassenarbeiten.length > 1 &&
                    <h6 className="mb-3">
                        Ihr Analysestand enthält <span className="fw-bold">{this.props.parentState.klassenarbeiten.length}</span> Klassenarbeiten.
                    </h6>
                }

                {this.props.parentState.klassenarbeiten.length > 0 &&
                    <>
                        <Row className="mt-3">
                            <Col>
                                <Table striped bordered hover size="sm" >
                                    <thead>
                                        <tr><th>Dateiname</th><th>Jahr</th><th>Fach</th><th>Klasse</th>
                                            <th>Sch&uuml;ler</th><th>Aufgaben</th><th>Punkte</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.props.parentState.klassenarbeiten.map((
                                            { schuljahr, fach, klasse, maxPunkte, grid, fileName, ...rest }, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{fileName}</td>
                                                    <td>{schuljahr}</td>
                                                    <td>{fach}</td>
                                                    <td>{klasse}</td>
                                                    <td>{grid.length}</td>
                                                    <td>{maxPunkte[0].length - 3}</td>
                                                    <td>{maxPunkte[0][maxPunkte[0].length - 1].value}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        <Alert variant="warning" className="alert-crits">
                            Hinweis:<br />
                            Falls Sie aktuell an einer Analyse arbeiten, speichern Sie diese Analyse bitte
                            vor dem Laden eines anderen Bearbeitungsstandes auf Ihrem lokalen Dateisystem ab. Durch
                            das Laden einer Analyse wird Ihr aktueller Stand vollst&auml;ndig ersetzt.

                        </Alert>
                        Hier können Sie Ihren aktuellen <Button
                            variant="outline-primary"
                            size="sm"
                            as={Link}
                            to="/auswertung/auswertung/speichern"
                            className="button-hover-white"
                        >
                            Analysestand
                        </Button> speichern.
                    </>
                }

                <Alert variant="info" className="alert-crits mt-3">
                    {/* <Button
                        variant="outline-primary"
                        size="sm"
                        className="button-hover-white me-3">
                        <label className="pointerFinger mb-0 text-primary" htmlFor="inputFileUpload">
                            Klicken Sie hier, um den einen Auswertungsstand von Ihrem lokalen Dateisystem zu laden.
                            <input
                                id="inputFileUpload"
                                type="file"
                                onChange={e => this.handleFileLoadChange(e, this)}
                                style={{ display: 'none' }}
                            />
                        </label>
                    </Button> */}
                    <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip className="exam-load-tooltip" id="tooltip-bottom">
                            Bitte klicken Sie hier, um den einen Analysestand von Ihrem lokalen Dateisystem zu laden.
                        </Tooltip>}
                        show={this.state.showLoadAnimation}
                    >
                        <Button
                            variant="outline-primary"
                            size="sm"
                            className={`me-3 button-hover-white ${this.state.showLoadAnimation ? 'blinking' : ''}`}
                            onClick={this.handleUploadButtonClick}
                        >
                            <label
                                className="pointerFinger button-hover-white"
                                htmlFor="inputFileUpload"
                                onClick={this.handleUploadLabelClick}
                            >
                                Klicken Sie hier, um den einen Analysestand von Ihrem lokalen Dateisystem zu laden.
                                <input
                                    id="inputFileUpload"
                                    type="file"
                                    accept=".json"
                                    onChange={e => this.handleFileLoadChange(e, this)}
                                    style={{ display: 'none' }}
                                />
                            </label>
                        </Button>
                    </OverlayTrigger>
                    Sie k&ouml;nnen einen Stand Ihrer Analyse von Ihrem lokalen Dateisystem in das
                    System laden und weiter nutzen.
                </Alert>

            </>
        )
    }
}

